import ContentAdapter from 'rise-ui/adapters/apis/rise-api/content.js';

import uiPageConfig from 'rise-ui/config/ui-page.js';
import { FetchOnce } from 'rise-ui/utils/adapter.js';

@FetchOnce()
export default class UiPageAdapter extends ContentAdapter {
  pathForType() {
    return uiPageConfig.contentType;
  }

  findRecord(store, type, id, snapshot) {
    id = (uiPageConfig.locations || {})[id] || uiPageConfig.locationTransform(id);
    return super.findRecord(store, type, id, snapshot, `filter[${uiPageConfig.locationField}]`);
  }
}
